module.exports = __webpack_public_path__ + "img/fullscreen_exit-24px.700f8479.svg";